<div
  class="tile-select tile-select--columns-{{ columns() }}"
  [class.tile-select--compact]="compact()"
  [class.tile-select--invalid]="invalid()"
  [class.tile-select--covers]="hasCovers()"
  [attr.role]="multiple() ? 'group' : 'radiogroup'"
>
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="tile-select__tile"
      [class.tile-select__tile--selected]="isSelected(option)"
      [class.tile-select__tile--cover]="!!option.cover"
      [attr.role]="multiple() ? null : 'radio'"
      [attr.aria-checked]="multiple() ? null : isSelected(option)"
      [attr.aria-pressed]="multiple() ? isSelected(option) : null"
      [disabled]="disabled()"
      (click)="toggle(option)"
    >
      @if (isSelected(option)) {
        <span class="material-icons tile-select__badge" aria-hidden="true">check</span>
      }

      @if (option.cover) {
        <span class="tile-select__cover" [style.background]="option.cover" aria-hidden="true">
          @if (option.tag) {
            <span class="tile-select__price">{{ option.tag | translate }}</span>
          }
        </span>
      }

      @if (option.svgIcon || option.iconSrc || option.icon) {
        <span class="tile-select__icon" aria-hidden="true">
          @if (option.svgIcon) {
            <svg-icon class="tile-select__svg-icon" [src]="option.svgIcon" />
          } @else if (option.iconSrc) {
            <img draggable="false" [src]="option.iconSrc" alt="" />
          } @else {
            <span class="material-icons">{{ option.icon }}</span>
          }
        </span>
      }

      <span class="tile-select__text">
        <span class="tile-select__label">{{ option.label | translate }}</span>
        @if (option.tag && !option.cover) {
          <span class="tile-select__tag">{{ option.tag | translate }}</span>
        }
        @if (option.description) {
          <span class="tile-select__description">{{ option.description | translate }}</span>
        }
        @if (option.features?.length) {
          <span class="tile-select__features">
            @for (feature of option.features; track feature) {
              <span class="tile-select__feature">
                <span class="material-icons" aria-hidden="true">check</span>
                {{ feature | translate }}
              </span>
            }
          </span>
        }
      </span>
    </button>
  }
</div>
